import { atom } from 'jotai';
export function createSetAtom<T>(initialValue: Set<T>) {
  const baseAtom = atom(initialValue);
  const onMount: typeof baseAtom['onMount'] = (baseAtom.onMount = (set) => {
    set(new Set<T>());
    return () => {
      set(new Set<T>());
    };
  });
  baseAtom.onMount = onMount;

  const valueAtom = atom((get) => get(baseAtom));
  const addAtom = atom(null, (get, set, newItem: T) => {
    set(baseAtom, new Set([...get(baseAtom).add(newItem)]));
  });
  const removeAtom = atom(null, (get, set, removeItem: T) => {
    set(baseAtom, new Set([...get(baseAtom)].filter((a) => a !== removeItem)));
  });

  const resetAtom = atom(null, (get, set) => {
    set(baseAtom, new Set());
  });

  const replaceAtom = atom(null, (get, set, newSet: Set<T>) => {
    set(baseAtom, newSet);
  });

  return { valueAtom, removeAtom, addAtom, resetAtom, replaceAtom };
}
